import React, { Component } from 'react';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import {Loader, ModalNextProvider} from '@jutro/components';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withValidation, validationPropTypes } from 'gw-portals-validation-react';
import { ContactService } from 'gw-capability-gateway';
import { messages as commonMessages } from 'gw-platform-translations';
import metadata from './EditContactComponent.metadata.json5';
import styles from './EditContactComponent.module.scss';
import messages from '../../Accounts/Accounts.messages';
import AddressComponent from "../Address/AddressComponent";
import {accountMessages} from "../../index";

class EditContactComponent extends Component {
    static contextType = TranslatorContext;

    state = {
        contactVM: {},
        selectedPhoneType: {
            homeRadioButton: '',
            workRadioButton: '',
            mobileRadioButton: ''
        },
        isLoading: true
    };

    static propTypes = {
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        contactData: PropTypes.shape({
            primaryAddress: PropTypes.shape({}).isRequired,
            emailAddress1: PropTypes.shape({}).isRequired,
            subtype: PropTypes.shape({}).isRequired,
            cellNumber: PropTypes.string.isRequired,
            homeNumber: PropTypes.string.isRequired,
            workNumber: PropTypes.string.isRequired,
            primaryPhoneType: PropTypes.string
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        showEditOnCancel: PropTypes.func.isRequired,
        ...validationPropTypes
    };

    componentDidMount = () => {
        let { contactVM, isLoading } = this.state;
        const model = {primaryAddress: {isFromPortal: true}};
        contactVM = this.createVM(model);
        this.initialContactData(contactVM);
        this.initializeRadioButton(contactVM);
        this.setState({
            isLoading: false
        });
    }

    cancelChanges = () => {
        const { contactData, showEditOnCancel } = this.props;
        showEditOnCancel(true, contactData);
    };

    initialContactData = (contactVM) => {
        const { contactData } = this.props;
        if (
            !_.isEmpty(contactData)
            && !_.isEmpty(contactData.primaryAddress)
        ) {
            _.set(contactVM, 'firstName.value', contactData.firstName);
            _.set(contactVM, 'contactName.value', contactData.contactName);
            _.set(contactVM, 'dateOfBirth.value', contactData.dateOfBirth);
            _.set(contactVM, 'lastName.value', contactData.lastName);
            _.set(contactVM, 'homeNumber.value', contactData.homeNumber);
            _.set(contactVM, 'workNumber.value', contactData.workNumber);
            _.set(contactVM, 'cellNumber.value', contactData.cellNumber);
            _.set(contactVM, 'faxNumber.value', contactData.faxNumber);
            _.set(contactVM, 'publicID.value', contactData.publicID);
            _.set(
                contactVM,
                'primaryAddress.value',
                contactData.primaryAddress
            );
            _.set(
                contactVM,
                'primaryAddress.isFromPortal.value',
                true
            );
            _.set(contactVM, 'emailAddress1.value', contactData.emailAddress1);
            _.set(
                contactVM,
                'primaryPhoneType.value',
                contactData.primaryPhoneType
            );
            this.setState({ contactVM });
        } else {
            return null;
        }
    };

    createVM = (model) => {
        const { viewModelService } = this.props;
        return viewModelService.create(
            model,
            'pc',
            'edge.capabilities.gateway.contact.dto.AccountContactDetailsDTO'
        );
    };

    initializeRadioButton = (contactVM) => {
        const { contactData } = this.props;
        const primaryPhone = _.get(contactVM, 'primaryPhoneType.value.code');
        let selectedPhone = primaryPhone || 'home';
        if (contactData.subtype === 'Company') {
            selectedPhone = primaryPhone || 'work';
        }

        if (!contactVM.primaryPhoneType.value) {
            _.set(
                contactVM,
                'primaryPhoneType.value',
                selectedPhone
            );
            this.setState({ contactVM });
        }

        this.setState({
            selectedPhoneType: {
                workRadioButton: selectedPhone === 'work' ? selectedPhone : '',
                homeRadioButton: selectedPhone === 'home' ? selectedPhone : '',
                mobileRadioButton: selectedPhone === 'mobile' ? selectedPhone : '',
            }
        });
    };

    updateAddress = (addressObj) => {
        const { contactVM } = this.state;
        _.set(contactVM, `primaryAddress.value`, addressObj);
        this.setState({ contactVM });
    }

    onAddressChange = (value, path) => {
        const { contactVM } = this.state;
        _.set(contactVM, `primaryAddress.${path}`, value);
        this.setState({ contactVM });
    }

    saveChanges = async () => {
        const { contactData, authHeader, showEditOnCancel } = this.props;
        /* const isValid = contactData.aspects.valid;
        if(isValid){ */

        const { contactVM, isLoading } = this.state;
        this.setState({
            isLoading: true
        });

        const requestObject = {
            accountId: contactData.associatedAccounts[0].accountNumber,
            anAccountContactDetailsDTO: contactVM.value
        };
        const translator = this.context;

        try {
            const updatedContact = await ContactService.updateAccountContact(requestObject.accountId, requestObject.anAccountContactDetailsDTO, authHeader);
            ModalNextProvider.showAlert({
                title: translator(messages.savedTitle),
                message: translator(messages.savedMessage),
                status: 'success',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);

            showEditOnCancel(true, updatedContact);

        } catch (ex) {
            console.log("Error: ", ex);
            ModalNextProvider.showAlert({
                title: translator(messages.savedTitle),
                message: 'Changes not saved',
                status: 'failure',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
        this.setState({
            isLoading: false
        });
    /* } else {
        ModalNextProvider.showAlert({
            title: translator(messages.savedTitle),
            message: 'Please enter the valid values',
            status: 'failure',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    } */
    };

    writeValue = (value, path) => {
        
        const { contactVM } = this.state;
        const phoneTypes = ['homeRadioButton', 'workRadioButton', 'mobileRadioButton'];
        _.set(contactVM, 'homeRadioButton', '');
        _.set(contactVM, 'workRadioButton', '');
        _.set(contactVM, 'mobileRadioButton', '');
        if (phoneTypes.includes(path)) {
            _.set(contactVM, path, value);
            _.set(contactVM, 'primaryPhoneType.value', value);
            _.set(contactVM, 'primaryPhoneType', value);
            this.setState({
                contactVM,
                selectedPhoneType: {
                    homeRadioButton: path === 'homeRadioButton' ? value : '',
                    workRadioButton: path === 'workRadioButton' ? value : '',
                    mobileRadioButton: path === 'mobileRadioButton' ? value : ''
                }
            });
        } else {
            _.set(contactVM, path, value);
            _.set(
                contactVM,
                'homeNumber',
                contactVM.homeNumber.value
            );
            _.set(
                contactVM,
                'contactData.value.workNumber',
                contactVM.workNumber.value
            );
            _.set(
                contactVM,
                'contactData.value.cellNumber',
                contactVM.cellNumber.value
            );
            _.set(
                contactVM,
                'contactData.value.faxNumber',
                contactVM.faxNumber.value
            );
            _.set(
                contactVM,
                'contactData.value.emailAddress1',
                contactVM.emailAddress1.value
            );
            _.set(
                contactVM,
                'contactData.value.firstName',
                contactVM.firstName.value
            );
            _.set(
                contactVM,
                'contactData.value.lastName',
                contactVM.lastName.value
            );
            _.set(
                contactVM,
                'contactData.value.dateOfBirth',
                contactVM.dateOfBirth.value
            );
            _.set(
                contactVM,
                'contactData.value.contactName',
                contactVM.contactName.value
            );
            this.setState({ contactVM });
        }
    };

    render() {
        const { contactVM, selectedPhoneType, isLoading } = this.state;
        const { contactData, isComponentValid, setComponentValidation } = this.props;
        const translator = this.context;
        const overrideProps = {
            '@field': {
                showOptional: false,
                showRequired: true
                
            },
            save: {
                disabled: !isComponentValid || !contactVM.aspects.valid || !contactVM.aspects.subtreeValid
            },
            homeRadioButtonId: {
                visible: !contactData.subtype === 'Company' || contactData.subtype === 'Person',
                value: selectedPhoneType.homeRadioButton ? 'home' : '',
                availableValues: [
                    {
                        code: 'home',
                        name: selectedPhoneType.homeRadioButton
                            ? translator(messages.primaryNumber)
                            : ''
                    }
                ]
            },
            workRadioButtonId: {
                value: selectedPhoneType.workRadioButton ? 'work' : '',
                availableValues: [
                    {
                        code: 'work',
                        name: selectedPhoneType.workRadioButton
                            ? translator(messages.primaryNumber)
                            : ''
                    }
                ]
            },
            mobileRadioButtonId: {
                /*visible:
                    !contactData.subtype === 'Company'
                    || contactData.subtype === 'Person',*/
                value: selectedPhoneType.mobileRadioButton ? 'mobile' : '',
                availableValues: [
                    {
                        code: 'mobile',
                        name: selectedPhoneType.mobileRadioButton
                            ? translator(messages.primaryNumber)
                            : ''
                    }
                ]
            },
            // mobilePhone: {
            //     /*visible:
            //         !(_.get(contactData, 'subtype') === 'Company')
            //         || (_.get(contactData, 'subtype') === 'Person'),*/
            //     required: _.get(contactData, 'primaryPhoneType.value') === 'mobile'

            // },
            homePhone: {
                visible:
                    !(_.get(contactData, 'subtype') === 'Company')
                    || (_.get(contactData, 'subtype') === 'Person'),
                //required: _.get(contactData, 'primaryPhoneType.value') === 'home'
                //required: true
            },
            // workPhone: {
            //    // required: selectedPhoneType.mobileRadioButton && this.mobileRadioButtonId.value === 'work'
            //     required: _.get(contactData, 'primaryPhoneType.value') === 'work'
            // },
            contactName: {
                visible: (_.get(contactData, 'subtype') === 'Company')
            },
            firstName: {
                visible: (_.get(contactData, 'subtype') === 'Person')
            },
            lastName: {
                visible: (_.get(contactData, 'subtype') === 'Person')
            },
            personDateOfBirth: {
                visible: (_.get(contactData, 'subtype') === 'Person')
            },
            accountAddressComponent: {
                model: contactVM.primaryAddress,
                //hideFields: ['addressLine3'],
                onValueChange: this.onAddressChange,
                onChangeAddress: this.updateAddress
            }


        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                saveChanges: this.saveChanges,
                cancelChanges: this.cancelChanges
            },
            resolveComponentMap: {
                addressComponent: AddressComponent
            }
        };

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const readValue = (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                contactVM,
                id,
                path,
                overrideProps
            );
        };
        return (
            <div>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={contactVM}
                    overrideProps={overrideProps}
                    classNameMap={resolvers.resolveClassNameMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    resolveValue={readValue}
                    onValueChange={this.writeValue}
                    onValidationChange={setComponentValidation}
                />
            </div>
        );
    }
}

export default withValidation(withViewModelService(withAuthenticationContext(EditContactComponent)));
